import React from "react";
import "./StepProgressIndicator.css";

// Presentational only. Single bookings skip the "Add learners" step
// (Steps.jsx routes step 2 -> 4), so the visible flow is 4 steps not 5.
export const StepProgressIndicator = ({ step, isMultiple }) => {
  const all = [
    { num: 1, label: "Your details" },
    { num: 2, label: "Billing" },
    { num: 3, label: "Learners" },
    { num: 4, label: "Review" },
    { num: 5, label: "Payment" },
  ];
  const flow = all.filter((s) => (isMultiple ? true : s.num !== 3));
  const idx = flow.findIndex((s) => s.num === Number(step));
  if (idx === -1) return null;
  const total = flow.length;
  const pct = total > 1 ? (idx / (total - 1)) * 100 : 0;

  return (
    <div className="step-progress">
      <div className="step-progress__head">
        <span className="step-progress__count">
          Step {idx + 1} of {total}
        </span>
        <span className="step-progress__label">{flow[idx].label}</span>
      </div>
      <div className="step-progress__bar">
        <div className="step-progress__fill" style={{ width: pct + "%" }} />
      </div>
      <div className="step-progress__dots">
        {flow.map((s, i) => (
          <div
            key={s.num}
            className={
              "step-progress__dot" +
              (i === idx ? " is-active" : "") +
              (i < idx ? " is-done" : "")
            }
            title={s.label}
          >
            <span>{i < idx ? "\u2713" : i + 1}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
